// @flow
import React from "react";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import Notification from "react-web-notification";
import _ from "lodash";
import moment from "moment";
import Tooltip from "react-tooltip";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import Actions from "../../../actions/Creators";
import MainMenu from "../mainMenu/MainMenu";
import Loader from "../loader/Loader";
import SearchInput from "../searchInput/SearchInput";
import Helper from "../../../helper/Helper";
import I18n from "../../../i18n/I18n";
import noonIcon from "../../../images/logo/noon2.png";
import TncContent from "../../tncContent/TncContent";
import Landing from "../landing/Landing";
import {
  Notifications as NotificationIcon,
  Profile,
  CountryToggle,
  ProductMenu,
  Icon
} from "../";
import styles from "./Layout.scss";

// const config = {
//   apiKey: "AIzaSyCsG2IaURb50ptch88kyuklkgtDEuEKeh8",
//   authDomain: "csel-235aa.firebaseapp.com",
//   databaseURL: "https://csel-235aa.firebaseio.com",
//   projectId: "csel-235aa",
//   storageBucket: "csel-235aa.appspot.com",
//   messagingSenderId: "251669362939"
// };

var config = {
  apiKey: "AIzaSyDly4Ev_B1EymTj3Mol1zJaZWFJHwnadlo",
  authDomain: "noonstg-partners.firebaseapp.com",
  databaseURL: "https://noonstg-partners.firebaseio.com",
  projectId: "noonstg-partners",
  storageBucket: "noonstg-partners.appspot.com",
  messagingSenderId: "803744686644"
};

firebase.initializeApp(config);

class Layout extends React.Component<Object> {
  state = {
    notification: "",
    notifications: [],
    ignore: true,
    title: ""
  };

  componentDidMount = () => {
    Scroll.animateScroll.scrollToTop({ delay: 0 });
    this.getP();
    if (this.props.location && this.props.location.search) {
      this.getParams(this.props.location.search);
    }
    if (this.props.seller && this.props.seller.id_partner) {
      let app = firebase
        .database()
        .ref(`notifications/${this.props.seller.id_partner}`);

      app.on("value", snapshot => {
        this.getData(snapshot.val());
      });
    }
  };
  getP = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function(m, key, value) {
        vars[key] = value;
      }
    );
    console.log("PART", vars);
    const newState = {};
    if (vars && vars.nav) {
      newState.nav = Boolean(vars.nav);
    }
    this.setState(newState);
  };
  getParams = searchString => {
    const params = URLSearchParams ? new URLSearchParams(searchString) : "";
    const nav = params && params.get("nav");
    const newState = {};
    if (nav) {
      newState.nav = Boolean(nav);
    }
    this.setState(newState);
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.notification &&
      prevProps.notification &&
      !_.isEqual(this.props.notification, prevProps.notification) &&
      this.props.notification.notifications &&
      prevProps.notification.notifications
    ) {
      const { notification } = this.props;
      if (
        notification &&
        notification.notifications &&
        !_.isEmpty(notification.notifications)
      ) {
        const { notifications } = notification;
        const latest = notifications[0];
        const message = latest[`message_${Helper.getLang()}`];
        this.handleButtonClick(message);
      }
    }
    if (
      this.props.seller &&
      this.props.seller !== prevProps.seller &&
      this.props.seller.id_partner
    ) {
      let app = firebase
        .database()
        .ref()
        .child(`notifications/${this.props.seller.id_partner}`);

      app.on("value", snapshot => {
        this.getData(snapshot.val());
      });
    }
  };
  componentWillReceiveProps = nextProps => {};
  handlePermissionGranted() {
    this.setState({
      ignore: false
    });
  }
  handlePermissionDenied() {
    this.setState({
      ignore: true
    });
  }
  handleNotSupported() {
    this.setState({
      ignore: true
    });
  }

  handleNotificationOnClick(e, tag) {
    const { notification } = this.props;
    if (
      notification &&
      notification.notifications &&
      !_.isEmpty(notification.notifications)
    ) {
      window.open(notification.notifications[0].directs_to_link);
    }
  }

  handleNotificationOnError(e, tag) {}

  handleNotificationOnClose(e, tag) {}

  handleNotificationOnShow(e, tag) {
    // this.playSound();
  }

  // playSound(filename){
  //   document.getElementById('sound').play();
  // }

  handleButtonClick = content => {
    if (this.state.ignore) {
      return;
    }

    const now = Date.now();

    const title =
      Helper.getLang() === "ar" ? "نون | موقع البائعين " : "noon | seller lab";

    const body = content;
    const tag = now;

    const lang = Helper.getLang();
    const dir = Helper.getLang() === "ar" ? "rtl" : "ltr";

    // Available options
    // See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
    const options = {
      tag: tag,
      body: body,
      icon: noonIcon,
      data: body,
      lang: lang,
      dir: dir,
      sound: "./sound.mp3" // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
    };
    this.setState({
      title: title,
      options: options
    });
  };

  getData = values => {
    let notificationsVal = values;
    let notifications = _(notificationsVal)
      .keys()
      .map(notificationKey => {
        let cloned = _.clone(notificationsVal[notificationKey]);
        cloned.key = notificationKey;
        return cloned;
      })
      .value();
    if (notifications.length > this.state.notifications.length) {
      this.getNotification();
      // this.handleButtonClick(
      //   notifications[notifications.length - 1].message_en
      // );
    }
    this.setState({
      notifications: notifications
    });
  };

  signout = () => {
    this.props.dispatch(Actions.logout());
  };

  acceptTerms = () => {
    this.props.dispatch(Actions.acceptTerms());
  };

  getNotification = () => {
    const query = "is_read=0";
    this.props.dispatch(Actions.getNotification(query));
  };

  postOutbound = itemCount => {
    const transfer = {
      item_count: itemCount
    };
    this.props.dispatch(Actions.postOutbound(transfer));
  };

  readNotification = notObj => {
    this.props.dispatch(Actions.readNotification(notObj));
  };

  render() {
    const {
      user,
      seller,
      isNoonUser,
      partnerCountries,
      partnerMenu,
      title,
      text
    } = this.props;
    const launchedAt = seller && seller.launched_at ? seller.launched_at : "";
    const count =
      this.props.notification &&
      this.props.notification.notifications &&
      !_.isEmpty(this.props.notification.notifications) &&
      this.props.notification.notifications.length;

    moment.locale(this.props.lang === "ar" ? "ar-ly" : "en");
    const lang = this.props.lang || "en";
    return (
      <div className={styles.mainContainer}>
        {I18n.getComponent(
          pageTitle => (
            <span>
              {I18n.getComponent(
                formattedValue => (
                  <Helmet title={formattedValue} />
                ),
                "layout.page-title",
                {
                  pageTitle: pageTitle,
                  count: count && count > 0 ? `(${count})` : ""
                }
              )}
            </span>
          ),
          this.props.title
        )}
        {!this.state.nav &&
        (this.props.isLoading || this.props.isSellerLoading) ? (
          <div>
            <Loader />
          </div>
        ) : (
          <div className={styles.container}>
            {(this.state.nav && !user) || user ? (
              <div className={styles.container}>
                {(this.state.nav && !seller) || seller ? (
                  (this.state.nav && !partnerCountries) ||
                  (partnerCountries && !_.isEmpty(partnerCountries)) ? (
                    <div>
                      {seller && (!launchedAt || launchedAt === "") ? (
                        <TncContent
                          acceptTerms={this.acceptTerms}
                          dispatch={this.props.dispatch}
                          countryCode={seller.country_code}
                          tnc={this.props.tnc}
                          isLoading={this.props.isTnCLoading}
                        />
                      ) : (
                        <div>
                          {seller && seller.store_status !== "Active" ? (
                            <Landing
                              banned
                              lang={this.props.lang}
                              reason={seller.ban_reason}
                              seller={seller}
                              signout={this.signout}
                            />
                          ) : (
                            <div className={styles.container}>
                              <div className={styles.sidePanel}>
                                <MainMenu
                                  menuOptions={partnerMenu}
                                  currentIndex={this.props.currentIndex}
                                  user={user}
                                  seller={seller}
                                  isNoonUser={isNoonUser}
                                  lang={this.props.lang}
                                  signout={this.signout}
                                  offerCount={this.props.offerCount}
                                  isOfferCounting={this.props.isOfferCounting}
                                  showPickup={
                                    seller &&
                                    seller.is_fm_integration &&
                                    Number(seller.is_fm_integration)
                                  }
                                  postOutbound={this.postOutbound}
                                />
                              </div>
                              <div
                                className={`${styles.content} ${
                                  this.props.onSearch ? styles.withSearch : ""
                                }`}
                              >
                                <div className={styles.totalWrapper}>
                                  {this.props.title ? (
                                    <div className={styles.header}>
                                      <h1 className={styles.title}>
                                        {I18n.getText(this.props.title, {})}
                                      </h1>
                                      {text && (
                                        <div className={styles.help}>
                                          <Tooltip
                                            className={styles.tooltip}
                                            place="bottom"
                                            type="light"
                                            border
                                            id={"text"}
                                            effect="solid"
                                          >
                                            <div>{text}</div>
                                          </Tooltip>
                                          <div
                                            style={{
                                              marginLeft: "2px",
                                              marginTop: "6px",
                                              marginRight: "5px"
                                            }}
                                            data-tip="custom show"
                                            data-event="click focus"
                                            data-for={"text"}
                                          >
                                            <Icon
                                              name="tooltip"
                                              className={styles.printIcon}
                                            />
                                          </div>
                                        </div>
                                      )}
                                      <div
                                        className={`${styles.searchWrapper} ${
                                          this.props.onSearch
                                            ? styles.onSearch
                                            : ""
                                        }`}
                                      >
                                        {this.props.onSearch ? (
                                          <SearchInput
                                            onSearch={this.props.onSearch}
                                            searchLabel={this.props.searchLabel}
                                            search={this.props.search}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>

                                      <NotificationIcon
                                        data={
                                          this.props.notification &&
                                          this.props.notification.notifications
                                        }
                                        readNotification={this.readNotification}
                                      />

                                      {this.props.user ? (
                                        <Profile
                                          user={this.props.user}
                                          seller={this.props.seller}
                                          signout={this.signout}
                                        />
                                      ) : (
                                        ""
                                      )}

                                      <a
                                        className={styles.toggleBtn}
                                        onClick={() => Helper.toggleLanguage()}
                                      >
                                        {I18n.getText(
                                          "header.language",
                                          {},
                                          "English"
                                        )}
                                      </a>
                                      {seller &&
                                      partnerCountries &&
                                      !_.isEmpty(partnerCountries) ? (
                                        <div className={styles.countryToggle}>
                                          <CountryToggle
                                            partnerCountries={partnerCountries}
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <Notification
                                    ignore={
                                      this.state.ignore &&
                                      this.state.title !== ""
                                    }
                                    notSupported={this.handleNotSupported.bind(
                                      this
                                    )}
                                    onPermissionGranted={this.handlePermissionGranted.bind(
                                      this
                                    )}
                                    onPermissionDenied={this.handlePermissionDenied.bind(
                                      this
                                    )}
                                    onShow={this.handleNotificationOnShow.bind(
                                      this
                                    )}
                                    onClick={this.handleNotificationOnClick.bind(
                                      this
                                    )}
                                    onClose={this.handleNotificationOnClose.bind(
                                      this
                                    )}
                                    onError={this.handleNotificationOnError.bind(
                                      this
                                    )}
                                    timeout={5000}
                                    title={this.state.title}
                                    options={this.state.options}
                                  />
                                  {this.props.children}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <Landing
                        user={this.props.user}
                        lang={this.props.lang}
                        signout={this.signout}
                        headerText={I18n.getText("landing.no-partner-header")}
                      />
                    </div>
                  )
                ) : (
                  <div>
                    <Landing
                      user={this.props.user}
                      headerText={I18n.getText("landing.header-text", {
                        user: user.firstName,
                        email: user.email
                      })}
                      subHeader={I18n.getText("landing.header-sub", {})}
                      noSeller
                      lang={this.props.lang}
                      signout={this.signout}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div>
                {window.location.replace(`${Helper.getLoginURL()}/${lang}/`)}
              </div>
            )}
          </div>
        )}
        <ToastContainer
          autoClose={3000}
          hideProgressBar
          position={"bottom-center"}
          className={styles.ma}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: state.session.isLoading,
    isSellerLoading: state.session.isSellerLoading,
    session: state.session,
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    partnerCountries: state.session.partnerCountries,
    partnerMenu: state.session.partnerMenu,
    isNoonUser: state.session.isNoonUser,
    notification: state.session.notification,
    tnc: state.session.tnc,
    isTnCLoading: state.session.isTnCLoading,
    offerCount: state.session.offerCount,
    isOfferCounting: state.session.isOfferCounting
  };
};

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/common/layout/Layout.js